import React, { useState, useEffect } from "react";
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.min.css";
import styles from "./imageCropper.module.css";
import {
    Button,
    Box
} from "@chakra-ui/react";
import { storage } from '../../src/config/firebase'
import { ref, getDownloadURL, uploadBytesResumable } from 'firebase/storage'


const ImageCropper = (props) => {

    const { fileName, changeStatus } = props;
    const [imageDestination, setImageDestination] = useState('')
    const [imageBlob, setImageBlob] = useState('')


    const getImgFromServer = async () => {
        let dpRef = ref(storage, `users/${props.id}/${fileName}/${fileName}`)
        const downloadURL = await getDownloadURL(dpRef)
        return downloadURL
    }

    const changeURL = async () => {
        props.setChangeStatus('loading')
        const downloadURL = await getImgFromServer()

        if (fileName === 'profilePicture') {
            props.mutation.mutate({
                photoURL: downloadURL
            })
        }

        else {


            props.mutation.mutate({
                brokeragePhoto: downloadURL
            })
        }

    }

    const imageElement = React.createRef()

    useEffect(() => {
        const cropper = new Cropper(imageElement.current, {
            // zoomable: true,
            scalable: false,
            // Aspect ratio must be 1 for profile pictures
            aspectRatio: fileName === 'profilePicture' ? 1 : NaN,
            crop: () => {
                const canvas = cropper.getCroppedCanvas({ fillColor: "white" });
                // canvas.toDataURL("image/png");

                setImageDestination(canvas.toDataURL("image/png"));

                canvas.toBlob(function (blob) {
                    setImageBlob(blob);
                }, 'image/jpeg');
            }
        });
    }, [])

    const handleSubmit = () => {
        if (changeStatus !== 'loading') {
            const fileRef = ref(storage, `users/${props.id}/${fileName}/${fileName}`)
            // uploadBytesResumable as shown here: https://firebase.google.com/docs/storage/web/upload-files#monitor_upload_progress
            const uploadTask = uploadBytesResumable(fileRef, imageBlob)
            uploadTask.on(
                'state_changed',
                null,
                null,
                function () {
                    changeURL();
                }
            )
        }

    }

    return (
        <div>
            <div className={styles.imgContainer}>
                <img ref={imageElement} src={props.src} alt="Loading..." />
            </div>


                <Box
                    textAlign="right">
                    <Button 
                        mr="16px"
                        isLoading={changeStatus === 'loading'}
                        loadingText="Submitting"
                    onClick={handleSubmit} size="sm" colorScheme="green" marginRight="1rem" marginBottom="0.75rem">
                        Submit
                    </Button>
                </Box>


        </div>
    );
}

export default ImageCropper;